/* Tour "dashboard-welcome" — visite guidée (room tour) du header au premier
   passage sur le Dashboard. Les boutons NE sont PAS cliquables : on les
   éclaire un à un (interactive: false) et l'utilisateur avance avec « Suivant ».
   À la fin, un panneau d'actions s'ouvre à gauche pour amorcer le premier usage. */

import './types';

window.FygrTour.register('dashboard-welcome', {
  title: 'Bienvenue sur Okimia',
  page: '/dashboard',
  interactive: false,
  intro: {
    title: 'Bienvenue sur Okimia',
    body: 'Découvrez votre tableau de bord : comptes, flux et trésorerie réunis en une vue d’ensemble. Nous vous présentons chaque élément pour une prise en main rapide.',
    note: 'D’autres guides apparaîtront au fil de votre navigation. Retrouvez-les à tout moment dans « Tutoriels ».',
    startLabel: 'Commencer',
    optoutLabel: 'Désactiver les guides automatiques',
    optoutNote: 'Ils ne s’afficheront plus automatiquement. Vous pourrez les relancer à tout moment depuis « Tutoriels ».',
  },
  steps: [
    {
      target: '[data-tour-step="comptes-pill"]',
      title: 'Vos comptes',
      body: 'Sélectionnez les comptes affichés ou regroupez plusieurs entités en une seule vue.',
      placement: 'bottom-start',
    },
    {
      target: '[data-tour-step="dash-currency"]',
      title: 'La devise',
      body: 'La devise d’affichage de votre trésorerie.',
      placement: 'bottom-start',
    },
    {
      target: '[data-tour-step="dash-period"]',
      title: 'La périodicité',
      body: 'La maille temporelle : jour, semaine ou mois, selon vos besoins.',
      placement: 'bottom-start',
    },
    {
      target: '[data-tour-step="dash-series"]',
      title: 'Les courbes affichées',
      body: 'Les données affichées : position de trésorerie, prévisionnel et scénarios.',
      placement: 'bottom',
    },
    {
      target: '[data-tour-step="dash-export"]',
      title: 'Exporter',
      body: 'Exportez vos données vers Excel pour les partager ou les retravailler.',
      placement: 'bottom',
    },
    {
      target: '[data-tour-step="dash-view"]',
      title: 'Graphique ou tableau',
      body: 'Basculez de la vue graphique à la vue tableau détaillée.',
      placement: 'bottom',
    },
    {
      target: '[data-tour-step="dash-scenario"]',
      title: 'Vos scénarios',
      body: 'Créez des scénarios pour comparer vos hypothèses et mesurer leur impact sur votre trésorerie.',
      placement: 'bottom-end',
    },
    {
      target: '[data-tour-step="dash-settings"]',
      title: 'Les paramètres',
      body: 'Les réglages d’affichage de votre tableau de bord et les options avancées.',
      placement: 'bottom-end',
    },
  ],
  celebration: {
    title: 'Vous avez fait le tour',
    body: 'Vous maîtrisez désormais les sections principales d’Okimia.',
    actionPanel: {
      title: 'Par où souhaitez-vous commencer ?',
      body: 'Lancez votre première action pour prendre Okimia en main.',
      actions: [
        {
          label: 'Saisir un objectif à la main',
          body: 'Ajustez un montant directement dans le tableau, étape par étape.',
          icon: 'edit',
          onSelect: () => {
            // Navigation complète (et pas start en place) : on repart d'un état
            // client propre, sinon des lignes fantômes du tuto précédent peuvent
            // casser le suivant. autoStart relance le guide via ?tour=.
            window.location.assign('/dashboard?tour=forecast-objectives&from=recap');
          },
        },
      ],
    },
  },
});

export {};
